/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { ComplianceFixReport } from '../models';
// @ts-ignore
import type { DatabaseOptimizerReport } from '../models';
// @ts-ignore
import type { ImageVulnerabilityRemediationReport } from '../models';
// @ts-ignore
import type { Status } from '../models';
// @ts-ignore
import type { WOOPRecommendationsSyncReport } from '../models';
/**
 * RunbookReportsAPIApi - axios parameter creator
 * @export
 */
export const RunbookReportsAPIApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Returns a Compliance fix report.
         * @summary Get Compliance Fix runbook report.
         * @param {string} organizationId The ID of the organization.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        runbookReportsAPIGetComplianceFixReport: async (organizationId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('runbookReportsAPIGetComplianceFixReport', 'organizationId', organizationId)
            const localVarPath = `/application-automation/v1alpha/organizations/{organizationId}/compliance-fix-reports`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns a Database Optimizer Report.
         * @summary Get Database Optimizer runbook report.
         * @param {string} organizationId The ID of the organization.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        runbookReportsAPIGetDatabaseOptimizerReport: async (organizationId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('runbookReportsAPIGetDatabaseOptimizerReport', 'organizationId', organizationId)
            const localVarPath = `/application-automation/v1alpha/organizations/{organizationId}/database-optimizer-reports`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns a ImageVulnerabilityRemediationReport.
         * @summary Get Image Vulnerability Remediation runbook report.
         * @param {string} organizationId The ID of the organization.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        runbookReportsAPIGetImageVulnerabilityRemediationReport: async (organizationId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('runbookReportsAPIGetImageVulnerabilityRemediationReport', 'organizationId', organizationId)
            const localVarPath = `/application-automation/v1alpha/organizations/{organizationId}/image-vulnerability-remediation-reports`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns a WOOP recommendations sync Report.
         * @summary Get WOOP recommendations sync runbook report.
         * @param {string} organizationId The ID of the organization.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        runbookReportsAPIGetWOOPRecommendationsSyncReport: async (organizationId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('runbookReportsAPIGetWOOPRecommendationsSyncReport', 'organizationId', organizationId)
            const localVarPath = `/application-automation/v1alpha/organizations/{organizationId}/woop-recommendations-sync-reports`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RunbookReportsAPIApi - functional programming interface
 * @export
 */
export const RunbookReportsAPIApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RunbookReportsAPIApiAxiosParamCreator(configuration)
    return {
        /**
         * Returns a Compliance fix report.
         * @summary Get Compliance Fix runbook report.
         * @param {string} organizationId The ID of the organization.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async runbookReportsAPIGetComplianceFixReport(organizationId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ComplianceFixReport>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.runbookReportsAPIGetComplianceFixReport(organizationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RunbookReportsAPIApi.runbookReportsAPIGetComplianceFixReport']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns a Database Optimizer Report.
         * @summary Get Database Optimizer runbook report.
         * @param {string} organizationId The ID of the organization.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async runbookReportsAPIGetDatabaseOptimizerReport(organizationId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DatabaseOptimizerReport>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.runbookReportsAPIGetDatabaseOptimizerReport(organizationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RunbookReportsAPIApi.runbookReportsAPIGetDatabaseOptimizerReport']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns a ImageVulnerabilityRemediationReport.
         * @summary Get Image Vulnerability Remediation runbook report.
         * @param {string} organizationId The ID of the organization.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async runbookReportsAPIGetImageVulnerabilityRemediationReport(organizationId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ImageVulnerabilityRemediationReport>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.runbookReportsAPIGetImageVulnerabilityRemediationReport(organizationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RunbookReportsAPIApi.runbookReportsAPIGetImageVulnerabilityRemediationReport']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns a WOOP recommendations sync Report.
         * @summary Get WOOP recommendations sync runbook report.
         * @param {string} organizationId The ID of the organization.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async runbookReportsAPIGetWOOPRecommendationsSyncReport(organizationId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WOOPRecommendationsSyncReport>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.runbookReportsAPIGetWOOPRecommendationsSyncReport(organizationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RunbookReportsAPIApi.runbookReportsAPIGetWOOPRecommendationsSyncReport']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * RunbookReportsAPIApi - factory interface
 * @export
 */
export const RunbookReportsAPIApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RunbookReportsAPIApiFp(configuration)
    return {
        /**
         * Returns a Compliance fix report.
         * @summary Get Compliance Fix runbook report.
         * @param {RunbookReportsAPIApiRunbookReportsAPIGetComplianceFixReportRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        runbookReportsAPIGetComplianceFixReport(requestParameters: RunbookReportsAPIApiRunbookReportsAPIGetComplianceFixReportRequest, options?: RawAxiosRequestConfig): AxiosPromise<ComplianceFixReport> {
            return localVarFp.runbookReportsAPIGetComplianceFixReport(requestParameters.organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns a Database Optimizer Report.
         * @summary Get Database Optimizer runbook report.
         * @param {RunbookReportsAPIApiRunbookReportsAPIGetDatabaseOptimizerReportRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        runbookReportsAPIGetDatabaseOptimizerReport(requestParameters: RunbookReportsAPIApiRunbookReportsAPIGetDatabaseOptimizerReportRequest, options?: RawAxiosRequestConfig): AxiosPromise<DatabaseOptimizerReport> {
            return localVarFp.runbookReportsAPIGetDatabaseOptimizerReport(requestParameters.organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns a ImageVulnerabilityRemediationReport.
         * @summary Get Image Vulnerability Remediation runbook report.
         * @param {RunbookReportsAPIApiRunbookReportsAPIGetImageVulnerabilityRemediationReportRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        runbookReportsAPIGetImageVulnerabilityRemediationReport(requestParameters: RunbookReportsAPIApiRunbookReportsAPIGetImageVulnerabilityRemediationReportRequest, options?: RawAxiosRequestConfig): AxiosPromise<ImageVulnerabilityRemediationReport> {
            return localVarFp.runbookReportsAPIGetImageVulnerabilityRemediationReport(requestParameters.organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns a WOOP recommendations sync Report.
         * @summary Get WOOP recommendations sync runbook report.
         * @param {RunbookReportsAPIApiRunbookReportsAPIGetWOOPRecommendationsSyncReportRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        runbookReportsAPIGetWOOPRecommendationsSyncReport(requestParameters: RunbookReportsAPIApiRunbookReportsAPIGetWOOPRecommendationsSyncReportRequest, options?: RawAxiosRequestConfig): AxiosPromise<WOOPRecommendationsSyncReport> {
            return localVarFp.runbookReportsAPIGetWOOPRecommendationsSyncReport(requestParameters.organizationId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for runbookReportsAPIGetComplianceFixReport operation in RunbookReportsAPIApi.
 * @export
 * @interface RunbookReportsAPIApiRunbookReportsAPIGetComplianceFixReportRequest
 */
export interface RunbookReportsAPIApiRunbookReportsAPIGetComplianceFixReportRequest {
    /**
     * The ID of the organization.
     * @type {string}
     * @memberof RunbookReportsAPIApiRunbookReportsAPIGetComplianceFixReport
     */
    readonly organizationId: string
}

/**
 * Request parameters for runbookReportsAPIGetDatabaseOptimizerReport operation in RunbookReportsAPIApi.
 * @export
 * @interface RunbookReportsAPIApiRunbookReportsAPIGetDatabaseOptimizerReportRequest
 */
export interface RunbookReportsAPIApiRunbookReportsAPIGetDatabaseOptimizerReportRequest {
    /**
     * The ID of the organization.
     * @type {string}
     * @memberof RunbookReportsAPIApiRunbookReportsAPIGetDatabaseOptimizerReport
     */
    readonly organizationId: string
}

/**
 * Request parameters for runbookReportsAPIGetImageVulnerabilityRemediationReport operation in RunbookReportsAPIApi.
 * @export
 * @interface RunbookReportsAPIApiRunbookReportsAPIGetImageVulnerabilityRemediationReportRequest
 */
export interface RunbookReportsAPIApiRunbookReportsAPIGetImageVulnerabilityRemediationReportRequest {
    /**
     * The ID of the organization.
     * @type {string}
     * @memberof RunbookReportsAPIApiRunbookReportsAPIGetImageVulnerabilityRemediationReport
     */
    readonly organizationId: string
}

/**
 * Request parameters for runbookReportsAPIGetWOOPRecommendationsSyncReport operation in RunbookReportsAPIApi.
 * @export
 * @interface RunbookReportsAPIApiRunbookReportsAPIGetWOOPRecommendationsSyncReportRequest
 */
export interface RunbookReportsAPIApiRunbookReportsAPIGetWOOPRecommendationsSyncReportRequest {
    /**
     * The ID of the organization.
     * @type {string}
     * @memberof RunbookReportsAPIApiRunbookReportsAPIGetWOOPRecommendationsSyncReport
     */
    readonly organizationId: string
}

/**
 * RunbookReportsAPIApi - object-oriented interface
 * @export
 * @class RunbookReportsAPIApi
 * @extends {BaseAPI}
 */
export class RunbookReportsAPIApi extends BaseAPI {
    /**
     * Returns a Compliance fix report.
     * @summary Get Compliance Fix runbook report.
     * @param {RunbookReportsAPIApiRunbookReportsAPIGetComplianceFixReportRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RunbookReportsAPIApi
     */
    public runbookReportsAPIGetComplianceFixReport(requestParameters: RunbookReportsAPIApiRunbookReportsAPIGetComplianceFixReportRequest, options?: RawAxiosRequestConfig) {
        return RunbookReportsAPIApiFp(this.configuration).runbookReportsAPIGetComplianceFixReport(requestParameters.organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns a Database Optimizer Report.
     * @summary Get Database Optimizer runbook report.
     * @param {RunbookReportsAPIApiRunbookReportsAPIGetDatabaseOptimizerReportRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RunbookReportsAPIApi
     */
    public runbookReportsAPIGetDatabaseOptimizerReport(requestParameters: RunbookReportsAPIApiRunbookReportsAPIGetDatabaseOptimizerReportRequest, options?: RawAxiosRequestConfig) {
        return RunbookReportsAPIApiFp(this.configuration).runbookReportsAPIGetDatabaseOptimizerReport(requestParameters.organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns a ImageVulnerabilityRemediationReport.
     * @summary Get Image Vulnerability Remediation runbook report.
     * @param {RunbookReportsAPIApiRunbookReportsAPIGetImageVulnerabilityRemediationReportRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RunbookReportsAPIApi
     */
    public runbookReportsAPIGetImageVulnerabilityRemediationReport(requestParameters: RunbookReportsAPIApiRunbookReportsAPIGetImageVulnerabilityRemediationReportRequest, options?: RawAxiosRequestConfig) {
        return RunbookReportsAPIApiFp(this.configuration).runbookReportsAPIGetImageVulnerabilityRemediationReport(requestParameters.organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns a WOOP recommendations sync Report.
     * @summary Get WOOP recommendations sync runbook report.
     * @param {RunbookReportsAPIApiRunbookReportsAPIGetWOOPRecommendationsSyncReportRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RunbookReportsAPIApi
     */
    public runbookReportsAPIGetWOOPRecommendationsSyncReport(requestParameters: RunbookReportsAPIApiRunbookReportsAPIGetWOOPRecommendationsSyncReportRequest, options?: RawAxiosRequestConfig) {
        return RunbookReportsAPIApiFp(this.configuration).runbookReportsAPIGetWOOPRecommendationsSyncReport(requestParameters.organizationId, options).then((request) => request(this.axios, this.basePath));
    }
}

